import React, {Component} from 'react'
import {Control, Errors, actions} from 'react-redux-form'
import {FormGroup, ControlLabel, FormControl, OverlayTrigger, Tooltip, Button} from 'react-bootstrap'
import {validators} from "../../../../utils/validators"
import PropTypes from 'prop-types';

class RequiredTextarea extends Component {
  constructor(props){
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  changeAction = (model, value) => {
    return (dispatch) => {
      dispatch(actions.change(model, value));
      dispatch(actions.resetValidity(model));
      if(typeof this.props.onChange === 'function') {
        this.props.onChange(value);
      }
    };
  };

  render(){
    const {model, label, controlId, errorLabel, tooltip, ...props} = this.props;

    return (
      <FormGroup controlId={controlId} validationState={this.state[errorLabel]}>
        {label && <ControlLabel>{label}*</ControlLabel>}
        {
          tooltip && <OverlayTrigger placement="left"
                                     overlay={<Tooltip id="tooltip" className="tooltip">{tooltip}</Tooltip>}>
            <Button className="tip pull-right">?</Button>
          </OverlayTrigger>
        }

        <Control.textarea
          model={model}
          validators={{required: validators.required(this.updateErrors, errorLabel)}}
          changeAction={this.changeAction}
          component={FormControl}
          componentClass="textarea"
          {...props}/>

        <Errors
          show={{touched: true, focus: false}}
          className="errors"
          model={model}
          messages={{
            required: 'This field is required',
            patternMismatch: 'Value does not match the required pattern'
          }}/>
      </FormGroup>
    )
  }
}

RequiredTextarea.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
};

RequiredTextarea.defaultProps = {
  controlId: Math.random().toString(16).substring(2),
  errorLabel: 'error',
};

export default RequiredTextarea;


// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-textarea.jsx